async function convertJsonSize(json){
  let ZOOM_OUT_NUM = 0.76; 
  let SVG = '<svg'; 
  let SVG_END = '/svg>';
  let SVG_HEIGHT_START = 'height="';
  let SVG_WIDTH_START = 'width="';
  let SVG_STRING_END = '"';
  let VIEWBOX_HEIGHT = 1;

  // console.log('json:',json);
  json = json.replace(/\ufeff/, "");
  // json = json.replace('width:467.8pt;', 'width:100%;');
  // json = json.replace('width:448.5pt;', 'width:100%;');
  // json = json.replace('width:428pt;', 'width:100%;');
  let returnRes = '';
  let res = json;
  let isRun = true;
  let check = json.indexOf(SVG);

  if(check == -1){
    return convertImageSize(json);
  }

  while(isRun){
    let left = res.indexOf(SVG);
    let txt = res.substring(0, left);

    if (txt != null && txt.length > 0) {
      returnRes = returnRes + txt;
    }
      

    res = res.substring(left, res.length);

    // console.log('res:',res);
    let height = 0;
    let heightLeft = res.substring(0, res.length).indexOf(SVG_HEIGHT_START);
    let heightRight = res.substring((heightLeft + SVG_HEIGHT_START.length), res.length).indexOf(SVG_STRING_END);

    if (heightLeft != -1 && heightRight != -1) {
      height = res.substring((heightLeft + SVG_HEIGHT_START.length), (heightLeft + SVG_HEIGHT_START.length + heightRight));

    }
      
    let width = 0;
    let widthLeft = res.substring(0, res.length).indexOf(SVG_WIDTH_START);
    let widthRight = res.substring((widthLeft + SVG_WIDTH_START.length), res.length).indexOf(SVG_STRING_END);

    if (widthLeft != -1 && widthRight != -1) {
      width = res.substring((widthLeft + SVG_WIDTH_START.length), (widthLeft + SVG_WIDTH_START.length + widthRight));
    }
      

    let right = res.substring(0, res.length).indexOf(SVG_END);
    // console.log('right:',right);
    let svgString = res.substring(0, (right + SVG_END.length)); 
    // console.log('svgString start:',svgString);
    // console.log('height:',parseFloat(height*ZOOM_OUT_NUM));
    // console.log('width:',parseFloat(width*ZOOM_OUT_NUM));

    let svgString2 = svgString.replace('height="'+height+'"','height="'+parseFloat(height*ZOOM_OUT_NUM).toFixed(3)+'"').replace('width="'+width+'"','width="'+parseFloat(width*ZOOM_OUT_NUM).toFixed(3)+'"').replace(height+'px',parseFloat(height*ZOOM_OUT_NUM).toFixed(3)+'px').replace(width+'px',parseFloat(width*ZOOM_OUT_NUM).toFixed(3)+'px');
    // console.log('svgString2:',svgString2);
    // svgString = svgString.replace(width, parseFloat(width*ZOOM_OUT_NUM).toString());

    let viewBox = ' viewBox="0 '+VIEWBOX_HEIGHT+' '+width+' '+height+'"';

    // console.log('viewBox:',viewBox);

    svgString2 = svgString2.slice(0, SVG.length) + viewBox + svgString2.slice(SVG.length , svgString2.length);
    // console.log('svgString end:',svgString2);

    returnRes = returnRes + svgString2;

    // console.log('res:',res);
    res = res.substring((right + SVG_END.length), res.length); 
    // console.log('res:',res);

    let end = res.indexOf(SVG);
    // console.log('end:',end);

    if(end == -1){
      isRun = false;
      returnRes = returnRes + res;
    }
  }
    
  return convertImageSize(returnRes);
}

async function convertImageSize(json){
  let ZOOM_OUT_NUM = 0.76; 
  let SVG = '<img'; 
  let SVG_END = '>';
  let SVG_HEIGHT_START = 'height="';
  let SVG_WIDTH_START = 'width="';
  let SVG_STRING_END = '"';

  // console.log('json:',json);
  let returnRes = '';
  let res = json;
  let isRun = true;
  let check = res.indexOf(SVG);

  if(check == -1){
    return convertTableSize(json);
  }

  while(isRun){
    let left = res.indexOf(SVG);
    let txt = res.substring(0, left);

    if (txt != null && txt.length > 0) {
      returnRes = returnRes + txt;
    }
      
    res = res.substring(left, res.length);

    // console.log('res:',res);
    let height = 0;
    let heightLeft = res.substring(0, res.length).indexOf(SVG_HEIGHT_START);
    let heightRight = res.substring((heightLeft + SVG_HEIGHT_START.length), res.length).indexOf(SVG_STRING_END);

    if (heightLeft != -1 && heightRight != -1) {
      height = res.substring((heightLeft + SVG_HEIGHT_START.length), (heightLeft + SVG_HEIGHT_START.length + heightRight));

    }
      
    let width = 0;
    let widthLeft = res.substring(0, res.length).indexOf(SVG_WIDTH_START);
    let widthRight = res.substring((widthLeft + SVG_WIDTH_START.length), res.length).indexOf(SVG_STRING_END);

    if (widthLeft != -1 && widthRight != -1) {
      width = res.substring((widthLeft + SVG_WIDTH_START.length), (widthLeft + SVG_WIDTH_START.length + widthRight));
    }
      

    let right = res.substring(0, res.length).indexOf(SVG_END);
    // console.log('right:',right);
    let svgString = res.substring(0, (right + SVG_END.length)); 
    // console.log('svgString start:',svgString);
    // console.log('height:',parseFloat(height*ZOOM_OUT_NUM));
    // console.log('width:',parseFloat(width*ZOOM_OUT_NUM));

    let svgString2 = svgString.replace('height="'+height+'"','height="'+parseFloat(height*ZOOM_OUT_NUM).toFixed(3)+'"').replace('width="'+width+'"','width="'+parseFloat(width*ZOOM_OUT_NUM).toFixed(3)+'"');
    // console.log('svgString2:',svgString2);
    // svgString = svgString.replace(width, parseFloat(width*ZOOM_OUT_NUM).toString());


    // console.log('viewBox:',viewBox);

    // console.log('svgString end:',svgString2);

    returnRes = returnRes + svgString2;

    // console.log('res:',res);
    res = res.substring((right + SVG_END.length), res.length); 
    // console.log('res:',res);

    let end = res.indexOf(SVG);
    // console.log('end:',end);

    if(end == -1){
      isRun = false;
      returnRes = returnRes + res;
    }
  }
    
  return convertTableSize(returnRes);
}

async function convertTableSize(json){
  let SVG = '<table'; 
  let SVG_END = '>';
  let SVG_WIDTH_START = 'style="width:';
  let SVG_STRING_END = 'pt;';

  // console.log('json:',json);
  let returnRes = '';
  let res = json;
  let check = res.indexOf(SVG);

  if(check == -1){
    return convertTdSize(json);
  }

  let left = res.indexOf(SVG);
  let txt = res.substring(0, left);

  if (txt != null && txt.length > 0) {
    returnRes = returnRes + txt;
  }
    
  res = res.substring(left, res.length);
    
  let width = 0;
  let widthLeft = res.substring(0, res.length).indexOf(SVG_WIDTH_START);
  let widthRight = res.substring((widthLeft + SVG_WIDTH_START.length), res.length).indexOf(SVG_STRING_END);

  if (widthLeft != -1 && widthRight != -1) {
    width = res.substring((widthLeft + SVG_WIDTH_START.length), (widthLeft + SVG_WIDTH_START.length + widthRight));
  }
    

  let right = res.substring(0, res.length).indexOf(SVG_END);
  let svgString = res.substring(0, (right + SVG_END.length)); 

  let svgString2 = svgString.replace('style="width:'+width+'pt;','style="width:100%;');
  // console.log('svgString2:',svgString2);

  returnRes = returnRes + svgString2;
  res = res.substring((right + SVG_END.length), res.length); 

  returnRes = returnRes + res;
    
  return convertTdSize(returnRes);
}
async function convertTdSize(json){
  let SVG = '<td'; 
  let SVG_END = '>';
  let SVG_WIDTH_START = 'style="width:';
  let SVG_STRING_END = 'pt;';

  // console.log('json:',json);
  let returnRes = '';
  let res = json;
  let check = res.indexOf(SVG);

  if(check == -1){
    return json;
  }

  let left = res.indexOf(SVG);
  let txt = res.substring(0, left);

  if (txt != null && txt.length > 0) {
    returnRes = returnRes + txt;
  }
    
  res = res.substring(left, res.length);
    
  let width = 0;
  let widthLeft = res.substring(0, res.length).indexOf(SVG_WIDTH_START);
  let widthRight = res.substring((widthLeft + SVG_WIDTH_START.length), res.length).indexOf(SVG_STRING_END);

  if (widthLeft != -1 && widthRight != -1) {
    width = res.substring((widthLeft + SVG_WIDTH_START.length), (widthLeft + SVG_WIDTH_START.length + widthRight));
  }
    

  let right = res.substring(0, res.length).indexOf(SVG_END);
  let svgString = res.substring(0, (right + SVG_END.length)); 

  let svgString2 = svgString.replace('style="width:'+width+'pt;','style="width:100%;');
  // console.log('svgString2:',svgString2);

  returnRes = returnRes + svgString2;
  res = res.substring((right + SVG_END.length), res.length); 

  returnRes = returnRes + res;
    
  return returnRes;
}

export { convertJsonSize };
